import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-summary',
  standalone: false,
  
  templateUrl: './payment-summary.component.html',
  styles: ``
})
export class PaymentSummaryComponent {

}
